export enum ThemeName {
  neutral = 'neutral',
  testuru = 'testuru',
}
